"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertIsGtmId = exports.GTM_ID_PATTERN = void 0;
/** GTM Container ID pattern. */
exports.GTM_ID_PATTERN = /^GTM-[0-9A-Z]+$/;
/**
 * Assert that the given id is a valid GTM Container ID.
 *
 * Tested against pattern: `/^GTM-[0-9A-Z]+$/`.
 *
 * @param id A GTM Container ID.
 */
function assertIsGtmId(id) {
    if (typeof id !== 'string' || !exports.GTM_ID_PATTERN.exec(id)) {
        const suggestion = String(id)
            .toUpperCase()
            .replace(/.*-|[^0-9A-Z]/g, '');
        const suggestionText = suggestion.length === 0 ? '' : ` Did you mean 'GTM-${suggestion}'?`;
        throw new Error(`'${id}' is not a valid GTM-ID (${exports.GTM_ID_PATTERN}).${suggestionText}`);
    }
}
exports.assertIsGtmId = assertIsGtmId;
//# sourceMappingURL=assert-is-gtm-id.js.map